import React from "react";
import { Link } from "react-router-dom";
const Footer = () => {
  return (
    <footer className="footer footer-four pt-4">
      {/* Footer Top */}
      <div className="footer-top aos" data-aos="fade-up">
        <div className="container">
          <div className="row">
            {/* Footer Contact */}
       <div className="col-lg-3">
  <div className="footer-contact footer-widget">
    <div className="footer-logo mb-3">
      <img src="/images/logo.jpg" className="img-fluid aos" alt="logo" />
    </div>

    <div className="footer-contact-info">
      <p className="text-white">
        We offer a diverse fleet of vehicles to suit every need, including compact cars, sedans, SUVs, and luxury vehicles.
      </p>

      {/* Phone */}
      <p className="d-flex align-items-center mb-2">
        <i className="fas fa-phone-alt me-2" style={{ color: "#CE8304" }}></i>
        <a href="tel:+919594849797" style={{ color: "#fff", textDecoration: "none" }}>+91 9594849797</a>
      </p>

      {/* Address */}
      <p className="d-fle align-items-start text-white">
        
        <h6><i className="fas fa-map-marker-alt me-2 mt-1 " style={{ color: "#CE8304" }}></i>Om Sai Cab Service</h6>
      Shree Vishal CHS Ltd.,
Office -13 Plot No.17, Sector 18, Kopar Khairane, Navi Mumbai, Maharashtra 400709

      </p>
    </div>





<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2871.7604903900215!2d73.0009432!3d19.1030017!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c18d6837bad9%3A0x76b9f3403b6d545d!2sOm%20Sai%20Cab%20Service%20-%20Cab%20Service%20in%20Navi%20Mumbai%20%7C%20Mumbai%20Airport%20Cab%20Service!5e1!3m2!1sen!2sin!4v1778847103556!5m2!1sen!2sin" width="100%" height="250" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>

    {/* <li className="d-flex gap-3">
              <a href="https://www.instagram.com/" target="_blank" rel="noreferrer">
                <i className="fab fa-instagram text-white"></i>
              </a>

              <a href="https://facebook.com/" target="_blank" rel="noreferrer">
                <i className="fab fa-facebook-f text-white"></i>
              </a>

              <a href="https://x.com/" target="_blank" rel="noreferrer">
                <i className="fab fa-twitter text-white"></i>
              </a>

               <a href="https://pinterest.com" target="_blank" rel="noreferrer">
                <i className="fab fa-pinterest-p text-white"></i>
              </a>
            </li> */}
  </div>
</div>

            {/* Footer Menus */}
            <div className="col-lg-9">
              <div className="row">
                <div className="col-lg-4 col-md-6">
                  <div className="footer-widget footer-menu">
                    <h5 className="footer-title">Our Services</h5>
                    <ul>
            
<li><Link to="/Mumbai-to-Goa-Cab"><i className="fa fa-car darkcolor"></i> Mumbai to Goa Cab</Link></li>
<li><Link to="/Mumbai-to-Goa-Cab-Booking"><i className="fa fa-car darkcolor"></i> Mumbai to Goa Cab Booking</Link></li>
<li><Link to="/Navi-Mumbai-to-Goa-Cab-Service"><i className="fa fa-car darkcolor"></i> Navi Mumbai to Goa Cab Service</Link></li>
<li><Link to="/Mumbai-Airport-to-Goa-Cab"><i className="fa fa-car darkcolor"></i> Mumbai Airport to Goa Cab</Link></li>
<li><Link to="/Mumbai-to-Goa-Cab-Service"><i className="fa fa-car darkcolor"></i> Mumbai to Goa Cab Service</Link></li>
<li><Link to="/Best-Mumbai-to-Goa-Cab-Service"><i className="fa fa-car darkcolor"></i> Best Mumbai to Goa Cab Service</Link></li>
<li><Link to="/Thane-to-Goa-Cabs"><i className="fa fa-car darkcolor"></i> Thane to Goa Cabs</Link></li>
<li><Link to="/Mumbai-to-Goa-Innova-Crysta-Cab"><i className="fa fa-car darkcolor"></i> Mumbai to Goa Innova Crysta Cab</Link></li>
<li><Link to="/Mumbai-to-Goa-One-Way-Cab"><i className="fa fa-car darkcolor"></i> Mumbai to Goa One Way Cab</Link></li>
<li><Link to="/Goa-Cabs-Service"><i className="fa fa-car darkcolor"></i> Goa Cabs Service</Link></li>
<li><Link to="/Goa-to-Mumbai-Cab"><i className="fa fa-car darkcolor"></i> Goa to Mumbai Cab</Link></li>
<li><Link to="/Goa-to-Navi-Mumbai-Cab"><i className="fa fa-car darkcolor"></i> Goa to Navi Mumbai Cab</Link></li>
       
          </ul>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6">
                  <div className="footer-widget footer-menu">
                    <h5 className="footer-title">Our Services</h5>
  <ul>
<li><Link to="/Goa-to-Mumbai-Airport-Cab"><i className="fa fa-car darkcolor"></i> Goa to Mumbai Airport Cab</Link></li>
<li><Link to="/Goa-to-Mumbai-One-Way-Cab"><i className="fa fa-car darkcolor"></i> Goa to Mumbai One Way Cab</Link></li>
<li><Link to="/Mumbai-to-Lonavala-Cab"><i className="fa fa-car darkcolor"></i> Mumbai to Lonavala Cab</Link></li>
<li><Link to="/Lonavala-to-Mumbai-Cab"><i className="fa fa-car darkcolor"></i> Lonavala to Mumbai Cab</Link></li>
<li><Link to="/Best-Lonavala-to-Navi-Mumbai-Cab"><i className="fa fa-car darkcolor"></i> Best Lonavala to Navi Mumbai Cab</Link></li>
<li><Link to="/Navi-Mumbai-Airport-Cab"><i className="fa fa-car darkcolor"></i> Navi Mumbai Airport Cab</Link></li>
<li><Link to="/Navi-Mumbai-Cab-Service"><i className="fa fa-car darkcolor"></i> Navi Mumbai Cab Service</Link></li>
<li><Link to="/Kharghar-Taxi-Services"><i className="fa fa-car darkcolor"></i> Kharghar Taxi Services</Link></li>
<li><Link to="/Mumbai-Airport-Cabs"><i className="fa fa-car darkcolor"></i> Mumbai Airport Cabs</Link></li>
<li><Link to="/Mumbai-Cab-Service"><i className="fa fa-car darkcolor"></i> Mumbai Cab Service</Link></li>
<li><Link to="/Mumbai-Online-Cab-Service"><i className="fa fa-car darkcolor"></i> Mumbai Online Cab Service</Link></li>
<li><Link to="/Mumbai-to-Mahabaleshwar-Cab"><i className="fa fa-car darkcolor"></i> Mumbai to Mahabaleshwar Cab</Link></li>

                    </ul>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6">
                  <div className="footer-widget footer-menu">
                    <h5 className="footer-title">Our Services</h5>
                    <ul>
<li><Link to="/Mumbai-Outstation-Cabs"><i className="fa fa-car darkcolor"></i> Mumbai Outstation Cabs</Link></li>
<li><Link to="/Innova-Crysta-On-Rent-in-Mumbai"><i className="fa fa-car darkcolor"></i> Innova Crysta On Rent in Mumbai</Link></li>
<li><Link to="/Ertiga-On-Rent-in-Mumbai"><i className="fa fa-car darkcolor"></i> Ertiga On Rent in Mumbai</Link></li>
<li><Link to="/Mumbai-to-Pune-Cabs"><i className="fa fa-car darkcolor"></i> Mumbai to Pune Cabs</Link></li>
<li><Link to="/Mumbai-Airport-to-Pune-Cab"><i className="fa fa-car darkcolor"></i> Mumbai Airport to Pune Cab</Link></li>
<li><Link to="/Cab-Service-in-Thane"><i className="fa fa-car darkcolor"></i> Cab Service in Thane</Link></li>
<li><Link to="/Cab-Service-in-Panvel"><i className="fa fa-car darkcolor"></i> Cab Service in Panvel</Link></li>
<li><Link to="/Sedan-Cab-Service-Mumbai"><i className="fa fa-car darkcolor"></i> Sedan Cab Service Mumbai</Link></li>
<li><Link to="/Mumbai-Darshan-Cab-Booking"><i className="fa fa-car darkcolor"></i> Mumbai Darshan Cab Booking</Link></li>
<li><Link to="/Book-Mumbai-to-Outstation-Cab-Service"><i className="fa fa-car darkcolor"></i> Book Mumbai to Outstation Cab Service</Link></li>
<li><Link to="/Mumbai-to-All-Maharashtra-Cab"><i className="fa fa-car darkcolor"></i> Mumbai to All Maharashtra Cab</Link></li>
<li><Link to="/Mumbai-to-Pan-India-Cab-Service"><i className="fa fa-car darkcolor"></i> Mumbai to Pan India Cab Service</Link></li>          
</ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <div className="container">
          <div className="copyright">
            <div className="row align-items-center row-gap-3 text-center">
              <div className="col-12">
                  <p className="copyright-text text-white">
              All Rights Reserved &copy;  <span className="darkcolorrr">Om Sai Cabs</span> <span id="date">{new Date().getFullYear()}</span>{' '}
                <span href="#"> Developed By </span> <a href="https://www.dexterintelligence.com/" className='d-inline' target="_blank" rel="noopener noreferrer">
                <span className="darkcolorrr">&nbsp;Dexter Intelligence</span>
              </a> | Hosted By <a href="https://www.urvahosting.com/" className='d-inline ' target="_blank" rel="noopener noreferrer">
                <span className="darkcolorrr">&nbsp;Urva Hosting</span>
              </a>
              </p>
              </div>
              {/* <div className="col-lg-4">
                <div className="payment-list">
                  <a href="javascript:void(0);">
                    <img src="/img/icons/payment-01.svg" alt="img" />
                  </a>
                  <a href="javascript:void(0);">
                    <img src="/img/icons/payment-02.svg" alt="img" />
                  </a>
                  <a href="javascript:void(0);">
                    <img src="/img/icons/payment-03.svg" alt="img" />
                  </a>
                </div>
              </div> */}
              {/* <div className="col-lg-4">
                <ul className="privacy-link">
                  <li><a href="privacy-policy.html">Privacy</a></li>
                  <li><a href="terms-condition.html">Terms & Condition</a></li>
                  <li><a href="javascript:void(0);">Refund Policy</a></li>
                </ul>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;


